var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA1\x9C\xEA\xB3\xA0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xEC\xB9\xB4\xEC\xB9\xB4\xEC\x98\xA4",
    d: "M9.99976 1.75049C5.04976 1.75049 0.999756 4.90049 0.999756 8.80049C0.999756 11.3005 2.64976 13.5005 5.19976 14.7505L4.34976 17.9005C4.29976 18.0005 4.34976 18.1005 4.39976 18.1505C4.44976 18.2005 4.49976 18.2505 4.59976 18.2505C4.64976 18.2505 4.69976 18.2505 4.74976 18.2005L8.39976 15.7505C8.94976 15.8505 9.49976 15.8505 9.99976 15.8505C14.9498 15.8505 18.9998 12.7005 18.9998 8.80049C18.9998 4.90049 14.9498 1.75049 9.99976 1.75049Z",
    fill: "#3C1D1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKakao);
export default __webpack_public_path__ + "static/media/ic_kakao.08422ca2e033bd7b91429f190bbecf33.svg";
export { ForwardRef as ReactComponent };